/*
 * Search New Products Modal
 */

import { connect } from 'react-redux';
import { values } from 'lodash';
import {
    IMaterial,
    IproductQueueObject,
    IsearchNewProductInstallBatchMode
} from '../../models';
import {
    saveProduct,
    toggleEditProductModal,
    toggleSearchNewProductsModal,
    getProducts,
    resetNewProducts,
    updateProductSearchFormValues,
    setProductSearchFormValues,
    setInstallBatchMode,
    setRememberProductSearchFilters,
    setRememberedProductSearchFilters,
    updateRememberedProductSearchFilters
} from '../../actions/manageInventoryActions';
import SearchNewProductsForm from './SearchNewProductsForm';
import { WithTranslation, withTranslation } from 'react-i18next';
import { WithCommonModal } from '../common/WithCommonModal';
import { selectIsLoading } from '../../reducers/commonReducers';
import { IinitialState } from '../../reducers';
import { getMergeableProducts } from '../../actions/manageProductQueueActions';

interface Iprops {
    selectedItem: IMaterial;
    selectedQueueObject?: IproductQueueObject;
    colorButton: string;
    handleProductSelect?: (
        product: IMaterial,
        installBatchMode: IsearchNewProductInstallBatchMode
    ) => void;
    handleMergeProduct: (product: IMaterial) => void;
    isApproved?: boolean;
    secondModal?: boolean;
    enableMergeProductMode: boolean;
    wideModal: boolean;
    disableCreateNew: boolean;
    isProductQueue?: boolean;
}

const mapStateToProps = (
    state: IinitialState,
    ownProps: Iprops & WithTranslation
) => {
    const installBatchMode: IsearchNewProductInstallBatchMode =
        state.manageInventory.searchNewProductInstallBatchMode;
    const newProducts = values(
        ownProps.isProductQueue
            ? state.manageProductQueue.mergeableProductsByID
            : state.manageInventory.newProducts
    ).filter(prod =>
        'name' in prod
            ? prod.id !== ownProps.selectedItem.id
            : prod.product.id !== ownProps.selectedItem.id
    );

    let title = ownProps.t('searchNewProductModalTitle');

    // Search and Replace
    if (ownProps.enableMergeProductMode) {
        title = ownProps.t('replaceProductModalTitle');
    }

    // Bulk change
    if (installBatchMode && installBatchMode.installBaseIDs.length > 0) {
        title = ownProps.t('searchNewProductModalTitleBulkChange', {
            count: installBatchMode.installBaseIDs.length
        });
    }

    return {
        user: state.user,
        loading: ownProps.isProductQueue
            ? state.manageProductQueue.mergeableProductsLoading
            : selectIsLoading(state),
        show: state.manageInventory.showSearchNewProductsModal,
        productInfo: state.productInfo,
        formValues: state.manageInventory.productSearchFormValues,
        rememberFilters: state.manageInventory.rememberProductSearchFilters,
        rememberedFilters: state.manageInventory.rememberedProductSearchFilters,
        newProducts: newProducts || [],
        className: 'search-products',
        title,
        secondModal: ownProps.secondModal,
        wideModal: ownProps.wideModal,
        disableCreateNew: ownProps.disableCreateNew,
        isProductQueue: ownProps.isProductQueue,
        installBatchMode
    };
};

export default withTranslation('manageInventory')(
    connect(mapStateToProps, {
        saveProduct,
        toggleEditProductModal,
        getProducts,
        getMergeableProducts,
        toggleModal: toggleSearchNewProductsModal,
        onHide: toggleSearchNewProductsModal,
        resetNewProducts,
        updateProductSearchFormValues,
        setProductSearchFormValues,
        setInstallBatchMode,
        setRememberProductSearchFilters,
        setRememberedProductSearchFilters,
        updateRememberedProductSearchFilters
    })(WithCommonModal(SearchNewProductsForm))
);
